import { cloudFunction } from 'services/parse';

export const fetchConfig = (keys) => {
  return cloudFunction('getConfig', { keys });
};

export const updateWorkingDayConfig= (key,value: any) => {
  return cloudFunction('updateConfigParam', { key, value });
};